/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Beneficiary } from './Beneficiary';
import {
    BeneficiaryFromJSON,
    BeneficiaryFromJSONTyped,
    BeneficiaryToJSON,
} from './Beneficiary';

/**
 * 
 * @export
 * @interface BeneficiariesViewModel
 */
export interface BeneficiariesViewModel {
    /**
     * 
     * @type {Array<Beneficiary>}
     * @memberof BeneficiariesViewModel
     */
    beneficiariesList: Array<Beneficiary>;
}

/**
 * Check if a given object implements the BeneficiariesViewModel interface.
 */
export function instanceOfBeneficiariesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "beneficiariesList" in value;

    return isInstance;
}

export function BeneficiariesViewModelFromJSON(json: any): BeneficiariesViewModel {
    return BeneficiariesViewModelFromJSONTyped(json, false);
}

export function BeneficiariesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeneficiariesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beneficiariesList': ((json['BeneficiariesList'] as Array<any>).map(BeneficiaryFromJSON)),
    };
}

export function BeneficiariesViewModelToJSON(value?: BeneficiariesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BeneficiariesList': ((value.beneficiariesList as Array<any>).map(BeneficiaryToJSON)),
    };
}

